import { XV1AppLoader } from './XV1AppLoader';
import { XV2AppLoader } from './XV2AppLoader';
const customLoaders = [];
const defaultLoaders = [
    {
        constructor: XV2AppLoader,
        supports: (appMetaData) => appMetaData.appType === 'XV2' || appMetaData.appType === 'XV2SPA'
    },
    { constructor: XV1AppLoader, supports: (appMetaData) => appMetaData.appType === 'XV1' }
];
export function registerLoader(strategy, isLowPriority = false) {
    let matcher;
    if (typeof strategy.supports === 'string' || Array.isArray(strategy.supports)) {
        const appType = typeof strategy.supports === 'string' ? [strategy.supports] : strategy.supports;
        matcher = (appMetaData, appConfig) => appType.indexOf(appMetaData.appType) !== -1;
    }
    else {
        matcher = strategy.supports;
    }
    const augmentedStrategy = {
        constructor: strategy.constructor,
        supports: matcher
    };
    if (isLowPriority) {
        customLoaders.push(augmentedStrategy);
    }
    else {
        customLoaders.unshift(augmentedStrategy);
    }
}
export function getLoaderConstructor(appMetaData, appConfig) {
    const loaderStrategy = ([...customLoaders, ...defaultLoaders].find((l) => l.supports(appMetaData, appConfig)));
    if (!loaderStrategy) {
        throw new Error(`Failed to find a suitable app loader for app ${appMetaData.id} with appType ${appMetaData.appType}`);
    }
    return loaderStrategy.constructor;
}
export function reset() {
    customLoaders.splice(0, customLoaders.length);
}
//# sourceMappingURL=loaderRegistry.js.map